<template>
  <v-container>
    <v-row>
      <v-col>
        <template>
          <v-file-input label="File input" ref="fileInput" accept="text/csv" outlined dense
            @change="readCSV"></v-file-input>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table :headers="headers" :items="items" :items-per-page="5" class="elevation-1">
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-btn color="success" @click="save">Сохранить</v-btn>
      </v-col>
      <v-col cols="1">
        <v-btn color="orange" @click="clear">Очистить</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <!-- <v-col>
        <v-card>
          <v-card-title>ID созданных товаров</v-card-title>
          <v-card-text v-for="(item, index) in result" :key="index">{{
            item
            }}</v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import { BX24 } from "bx24";

export default {
  name: "App",

  data() {
    return {
      type: "",
      inputFile: "",
      headers: [
        { text: "Артикул", value: "articl" },
        // {
        //   text: "Категория",
        //   value: "h",
        // },
        { text: "Название", value: "title" },
        { text: "Количество", value: "quest" },
        // { text: "Площадь ед.", value: "square" },
        { text: "Вес", value: "weight" },
        { text: "Себестоимость", value: "price" },
        { text: "Цена", value: "priceRent" },
        { text: "Примечание", value: "comment" },
      ],
      products: [],
      items: [],
      file: "",
      users: [],
      result: [],
      url: "https://adminka.bitrix24.ru/rest/3686/skqaqzp3aefsth6q/",
      arrayProduct: []
    };
  },
  methods: {
    readCSV() {
      const file = this.$refs.fileInput.$refs.input.files[0];
      if (file) {
        new Promise(function (resolve, reject) {
          const reader = new FileReader();
          reader.onload = function (evt) {
            resolve(evt.target.result);
          };
          reader.readAsText(file, 'windows-1251');
          reader.onerror = reject;
        })
          .then(this.processFileContent)
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    processFileContent(data) {
      this.file = data.split("\n");
      this.setItems();
      // console.log(this.file)
    },
    async setItems() {
      try {
        this.type = this.file[0].split("\r")[1];
        this.file.splice(0, 1);
        console.log(this.file)
        for (const elem of this.file) {
          if (elem) {
            const elemAray = elem.split(";");
            const item = {
              articl: elemAray[2] ? elemAray[2].trim() : "",
              quest: elemAray[4] ? elemAray[4].trim() : 1,
              // h: elemAray[2] ? elemAray[2].trim() : 400,
              title: elemAray[1] ? elemAray[1].replace(/['"«»]/g, "") : "",
              // square: elemAray[4] ? elemAray[4].trim() : "",
              weight: elemAray[9] ? elemAray[9].trim() : 0,
              price: elemAray[7] ? elemAray[7].trim() : 0,
              priceRent: elemAray[5] ? elemAray[5].trim() : 0,
              comment: elemAray[11] ? elemAray[11].trim() : '',
            };
            this.items.push(item);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    clear() {
      this.items = [];
      this.file = "";
      this.inputFile = "";
    },
    async getProducts() {
      const req = await axios.post('https://spa-bitrix.ru/webhooks/alfateh/addProductFromXls/batch.php')
      this.products.push(...req.data)
      // console.log(this.products)
    },
    async getSession() {
      const bx24 = new BX24();
      console.log('Инициализация завершена!', bx24.placement.info());
    },
    async save() {
      await this.getProducts()
      //TODO нужно получить ID сделки в которой происходит открытие приложения
      // const ownerId = 'id'
      // const params = {
      //   fields: {
      //     ownerId: ownerId,
      //     ownerType: 'D',
      //     productName: 'title product',
      //     price: 'price product',
      //     quantity: 'quantity product'
      //   }
      // }

      try {
        this.getSession()
        this.arrayProduct = []
        for (const index in this.items) {
          if (this.items[index].title !== '') {
            const searchProduct = this.products.filter((elem) => elem.NAME == this.items[index].title)[0]

            this.arrayProduct.push({
              productId: searchProduct ? searchProduct.ID : '',
              price: this.items[index].priceRent ? this.items[index].priceRent : 0,
              quantity: this.items[index].quest ? this.items[index].quest : 1
            })

            // batchParams.cmd[  //заносим в батч запрос на создание товара
            //   index
            // ] = `crm.item.productrow.add?fields[iblockId]=14&fields[iblockSectionId]=null&fields[name]=${this.items[index].title}`; //при создании указываем только название

            // if (index % 50 == 0 || index == Number(this.items.length) - 1) { //если запросов 50 или запрос последний запускаем процесс создания товаров в битрик
            //   console.log({ batchParams });
            //   const result = await axios.post(this.url + "batch", batchParams);
            //   console.log({ result });
            //   for (const itemIndex in result.data.result.result) { //перебираем созданные товары
            //     console.log({ itemIndex });
            //     console.log(result.data.result.result[itemIndex]);
            //     this.items[itemIndex].parentID =
            //       result.data.result.result[itemIndex].sku.id; //заносим в массив товаров их id
            //   }
            //   batchParams.cmd = {}; //чистим батч для последующих запросов после создания товаров
            // }
            // console.log(this.items, "items");
          } //перебираем массив товаров
        }
        const paramsAddProduct = {
          ownerType: 'D',
          ownerId: 17116,
          productRows: this.arrayProduct
        }
        const test = await axios.post(
          this.url + 'crm.item.productrow.set', paramsAddProduct,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        console.log(test, 'test')
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
